import AccountGreeting from 'components/Header/AccountGreeting/AccountGreeting';
import { withAccountGreetingProps } from 'viewModel/header/accountGreeting/withAccountGreetingProps';

export default withAccountGreetingProps(AccountGreeting);
